import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormHelperText from "@mui/material/FormHelperText";
import isBoolean from "lodash/isBoolean";
import isFunction from "lodash/isFunction";
import { useEffect, useMemo } from "react";
import { Field } from "react-final-form";
import { FIELD_TYPES, useFormContext } from "../../../context/FormContext";
import { VALIDATOR_REQUIRE } from "../../../utils/finalForm/validators/VALIDATOR_REQUIRE";
import CheckboxRow from "../shared/CheckboxRow";
import RffInputWrapper from "../shared/RffInputWrapper";

const RffBooleanCheckbox = ({
  name,
  label,
  required = false,
  row = false,
  suppressGrid,
  onChange,
  size,
  helperText,
  sx,
  // Renders the bordered, tint-on-check row instead of a bare control — for
  // "check all that apply" lists, where the rows need to read as one set and
  // sit alongside RffCheckboxArrayField's rows.
  boxed = false,
}) => {
  const { registerFieldType } = useFormContext();

  const validate = useMemo(
    () => (required ? VALIDATOR_REQUIRE : undefined),
    [required],
  );

  useEffect(() => {
    if (name) {
      registerFieldType(name, FIELD_TYPES.BOOLEAN_CHECKBOX);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [name]);

  return (
    <RffInputWrapper
      suppressGrid={suppressGrid}
      size={size}
      required={required}
      row={row}
      label={row ? label : null}
      helperText={helperText}
    >
      <Field
        name={name}
        validate={validate}
        render={({ input, meta }) => {
          const checked = isBoolean(input.value) ? input.value : false;

          const handleChange = (nextValue) => {
            input.onChange(nextValue);
            if (isFunction(onChange)) {
              onChange(nextValue);
            }
          };

          if (boxed) {
            return (
              <>
                <CheckboxRow
                  label={label}
                  checked={checked}
                  onChange={handleChange}
                  sx={sx}
                />
                {meta.touched && meta.error && (
                  <FormHelperText sx={{ ml: 1 }} error>
                    {meta.error}
                  </FormHelperText>
                )}
              </>
            );
          }

          return (
            <>
              <FormControlLabel
                sx={{
                  marginRight: row ? 0 : "16px",
                  span: {
                    fontSize: "13px !important",
                  },
                  ...sx,
                }}
                control={
                  <Checkbox
                    size="small"
                    checked={checked}
                    onChange={(event) => handleChange(event.target.checked)}
                    data-type={FIELD_TYPES.BOOLEAN_CHECKBOX}
                  />
                }
                label={row ? null : label}
              />
              {meta.touched && meta.error && (
                <FormHelperText sx={{ ml: 3 }} error>
                  {meta.error}
                </FormHelperText>
              )}
            </>
          );
        }}
      />
    </RffInputWrapper>
  );
};

export default RffBooleanCheckbox;
